import type { ImageConfigProps } from '@modules/images';
import { getPreloadImageLink } from '@modules/images';
import {
    BANNER_IMAGE_FILE_ADDRESS_COMBINED_PATH,
    CATEGORY_IMAGE_COMBINED,
} from '../component/ap-connect-banner/constants';
import { getImagesSizes } from '~/utils/image-sizes-utils';
import type { MetaDescriptor } from '@remix-run/node';

export const prefetchAPConnectBannerImage = (
    assetsBaseUrl: string,
    isMobile = false,
    imageConfigProps?: ImageConfigProps
): MetaDescriptor[] => {
    const imageUrl =
        assetsBaseUrl +
        BANNER_IMAGE_FILE_ADDRESS_COMBINED_PATH +
        CATEGORY_IMAGE_COMBINED;
    const imageSizes = getImagesSizes({
        desktop: 852,
        mobile: 491,
    });

    const link = isMobile
        ? getPreloadImageLink(imageConfigProps, undefined, imageUrl, imageSizes)
        : getPreloadImageLink(
              imageConfigProps,
              imageUrl,
              undefined,
              imageSizes
          );
    return link;
};
